var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mostrarBloco
    ? _c(
        "div",
        { staticClass: "asset-performance-chart" },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-wrap align-center mb-2" },
            [
              _c(
                "h3",
                {
                  staticClass:
                    "az-text-primary az-size-16 font-semibold mr-auto d-flex align-center"
                },
                [
                  _vm._v(" " + _vm._s(_vm.title) + " "),
                  _vm.notaMoeda
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: {
                            right: "",
                            "max-width": "320",
                            "open-delay": "300"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "icon-svg",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "ml-1",
                                            attrs: {
                                              name: "mdi-information-outline",
                                              size: 16,
                                              color: "secondary"
                                            }
                                          },
                                          "icon-svg",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            892860840
                          )
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.notaMoeda))])]
                      )
                    : _vm._e()
                ],
                1
              ),
              !_vm.hideModeToggle
                ? _c("BaseToggleButton", {
                    staticClass: "mr-2",
                    attrs: {
                      value: _vm.mode,
                      small: "",
                      segmented: "",
                      options: _vm.modeOptions
                    },
                    on: { change: _vm.changeMode }
                  })
                : _vm._e(),
              _c("BaseToggleButton", {
                attrs: {
                  value: _vm.period,
                  small: "",
                  segmented: "",
                  options: _vm.periodOptions
                },
                on: { change: _vm.changePeriod }
              })
            ],
            1
          ),
          !_vm.isPatrimonio && !_vm.hideBenchmarksMenu
            ? _c(
                "div",
                { staticClass: "d-flex justify-end mb-2" },
                [
                  _c("BenchmarksMenu", {
                    attrs: {
                      value: _vm.benchmarksSelecionados,
                      benchmarks: _vm.benchmarksDoMenu,
                      "available-benchmark-names": _vm.nomesDisponiveis
                    },
                    on: {
                      input: function($event) {
                        return _vm.$emit("change-benchmarks", $event)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "FeedbackWrapper",
            {
              attrs: {
                loading: _vm.loading,
                "no-data": !_vm.hasData,
                message: _vm.mensagemSemDados,
                "min-height": _vm.ASSET_CHART_HEIGHT,
                bordered: ""
              }
            },
            [
              _vm.isPatrimonio
                ? _c("bar-chart", {
                    key: _vm.chartKey,
                    attrs: {
                      "chart-data": _vm.chartData,
                      plugins: _vm.chartPlugins,
                      options: _vm.chartOptions,
                      height: _vm.ASSET_CHART_HEIGHT
                    }
                  })
                : _c("line-chart", {
                    key: _vm.chartKey,
                    attrs: {
                      "chart-data": _vm.chartData,
                      plugins: _vm.chartPlugins,
                      options: _vm.chartOptions,
                      height: _vm.ASSET_CHART_HEIGHT
                    }
                  })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }